var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L10.3243 9.63058C10.7066 9.98104 11.2934 9.98105 11.6757 9.63058L20 2",
    stroke: "#FF6B00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
};

export default __webpack_public_path__ + "static/media/arrow-down.4f26a526.svg";
export { SvgArrowDown as ReactComponent };